import { ContentSectionBlocks } from "~/landing-pages/components/ContentSections/ContentSectionBlocks";
import { blockStyle } from "~/landing-pages/components/ContentSections/shared-content-section-styles";
import {
  eyebrowColorStyle,
  primaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { Headline } from "~/ui-library";
import { BaseContentSectionProps } from "../content-section-shared-types";

type ContentSectionProps = Omit<
  BaseContentSectionProps,
  "imageAlt" | "imageUrl"
>;

export const ContentSection: React.FC<ContentSectionProps> = ({
  appearance,
  eyebrow,
  headline,
  contentBlocks,
}): JSX.Element => (
  <div className={blockStyle({ appearance })}>
    <div className="lg:flex lg:justify-between xl:justify-end">
      <div className="w-full lg:ml-8 lg:mr-0 lg:max-w-lg lg:flex-none">
        <Headline
          as="div"
          className={eyebrowColorStyle({ appearance, className: "mb-2" })}
          level={6}
        >
          {eyebrow}
        </Headline>
        <Headline
          level={2}
          as="h2"
          className={primaryTextColorStyle({ appearance })}
        >
          {headline}
        </Headline>
        <div className="mt-10 max-w-xl text-gray-700 lg:max-w-none">
          <ContentSectionBlocks
            contentBlocks={contentBlocks}
            appearance={appearance}
            data-testid="content_blocks"
          />
        </div>
      </div>
    </div>
  </div>
);
